import { Link, NavLink, useNavigate } from "react-router-dom";
import { ShieldCheck, LogOut, UserRound, LayoutDashboard } from "lucide-react";
import { useAuth } from "../context/AuthContext";

function StatusPill({ user }) {
  if (user.role === "admin")
    return (
      <span className="badge-verified" data-testid="nav-verification-status-button">
        <ShieldCheck size={12} /> Admin
      </span>
    );
  if (user.verification_status === "verified")
    return (
      <span className="badge-verified" data-testid="nav-verification-status-button">
        <ShieldCheck size={12} /> Video Verified
      </span>
    );
  if (user.verification_status === "scheduled")
    return (
      <Link to="/verification" className="badge-pending" data-testid="nav-verification-status-button">
        Interview Scheduled
      </Link>
    );
  return (
    <Link to="/verification" className="badge-pending" data-testid="nav-verification-status-button">
      Verification Needed
    </Link>
  );
}

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  const linkCls = ({ isActive }) =>
    `text-sm font-medium transition-colors ${isActive ? "text-[#1F3A34]" : "text-stone-500 hover:text-stone-800"}`;

  return (
    <header className="sticky top-0 z-50 bg-[#FAF8F5]/90 backdrop-blur-md border-b border-[#E7DFD5]/80">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-2" data-testid="nav-brand-logo">
          <span className="w-8 h-8 rounded-full bg-[#1F3A34] text-[#FAF8F5] flex items-center justify-center">
            <ShieldCheck size={16} />
          </span>
          <span className="font-display text-xl font-semibold text-[#1C1917]">
            Veritas<span className="text-[#C58342]">40+</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-7">
          <NavLink to="/discover" className={linkCls} data-testid="nav-discover-link">
            Discover
          </NavLink>
          <NavLink to="/matches" className={linkCls} data-testid="nav-matches-link">
            Matches
          </NavLink>
          <NavLink to="/pricing" className={linkCls} data-testid="nav-membership-link">
            Membership
          </NavLink>
          <NavLink to="/verification" className={linkCls} data-testid="nav-verification-link">
            Verification
          </NavLink>
          {user?.role === "admin" && (
            <NavLink to="/admin" className={linkCls} data-testid="nav-admin-portal-link">
              <span className="inline-flex items-center gap-1">
                <LayoutDashboard size={14} /> Admin
              </span>
            </NavLink>
          )}
        </nav>

        <div className="flex items-center gap-3">
          {user ? (
            <>
              <StatusPill user={user} />
              <Link
                to="/profile"
                className="w-9 h-9 rounded-full bg-[#F3EFEA] border border-[#E7DFD5] flex items-center justify-center text-stone-600 hover:text-stone-900 transition-colors"
                title="My profile"
                data-testid="nav-profile-link"
              >
                <UserRound size={16} />
              </Link>
              <button
                onClick={handleLogout}
                className="text-stone-500 hover:text-stone-900 transition-colors"
                title="Log out"
                data-testid="nav-logout-button"
              >
                <LogOut size={18} />
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="text-sm font-medium text-stone-600 hover:text-stone-900" data-testid="nav-login-button">
                Log in
              </Link>
              <Link to="/register" className="btn-primary !px-5 !py-2 text-sm" data-testid="nav-register-button">
                Join Verified
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
